import React, { useEffect, useState, useContext } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import LocalGroceryStoreOutlined from "@mui/icons-material/LocalGroceryStore";
import Hail from "@mui/icons-material/Hail";
import HistoryRoundedIcon from "@mui/icons-material/HistoryOutlined";
import { BasketHelper } from "../../../core/utils/BasketHelper";
import ApiBasket from "../../../core/api/api.basket";
import SplitNumber from "../_Components/SplitNumber";
import { TextField } from "@mui/material";
import { IconDelete, IconEmptyBasket, IconGift } from "../../../_metronic/css/icons";
import ContextApp from "../../../core/contexts/context.app";
import _ from "lodash";
import Swal from "sweetalert2";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BasketStorage from "./Component/BasketStorage";
import SwalMessage from "../_Components/SwalMessage";

const Basket = () => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();
  const navigate = useNavigate();
  const ctx = useContext(ContextApp);
  const [basket, setBasket] = useState();
  const [loaderDot, setLoaderDot] = useState(false);
  const [minMaxIsUpdated, setMinMaxIsUpdated] = useState(false);

  useEffect(() => {
    (async () => {
      let basketTemp = await BasketHelper.getBasketFromStorage(ctx);
      if (!_.isEmpty(basketTemp)) {
        setBasket(basketTemp);
        if (
          !_.isEmpty(ctx.basketInfo) &&
          !_.isEmpty(ctx.basketInfo.promoCode)
        ) {
          // setValue("promoCode", ctx.basketInfo.promoCode);
          //setPromoCodeIsSuccess(true);
        }
      }
    })();
  }, [ctx.basketInfo]);
  /** اسکرول به بالای صفحه ******************/
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  // تابع برای تبدیل اعداد فارسی به انگلیسی
  const convertToEnglishNumbers = (input) => {
    const persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    const englishNumbers = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

    let converted = input
      .split("")
      .map((char) => {
        const index = persianNumbers.indexOf(char);
        return index !== -1 ? englishNumbers[index] : char;
      })
      .join("");

    return converted;
  };
  /******حذف کاراکترهای حروفی***************/
  const handleInputChange = (e, field) => {
    // فقط اعداد را اجازه بده
    let value = e.target.value;
    value = convertToEnglishNumbers(value); // تبدیل اعداد فارسی به انگلیسی
    value = value.replace(/\D/g, ""); // حذف هر کاراکتر غیر عددی
    field.onChange(value);
    setValue("mobileNumber", value, { shouldValidate: true });
  };

  const handleKeyPress = (e) => {
    // فقط اعداد را اجازه بده
    if (!/[0-9۰-۹]/.test(e.key)) {
      e.preventDefault(); // جلوگیری از وارد شدن حروف
    }
  };
  /*** تایمر ******************** */
  const initialTime = 10 * 60; // 10 دقیقه به ثانیه
  const [timeLeft, setTimeLeft] = useState(() => {
    const savedTime = localStorage.getItem("timeLeft");
    return savedTime ? JSON.parse(savedTime) : initialTime;
  });
  async function changeBasket(item, basketItemCount) {
    try {
      // if (!loaderDot) {
      //   setLoaderDot(true);
      // }
      await BasketHelper.changeBasketItemTotalCount(
        ctx,
        item,
        basketItemCount,
        minMaxIsUpdated
      );
      setMinMaxIsUpdated(true);
      setLoaderDot(false);
    } catch (error) {
      setLoaderDot(false);
    }
  }
  // useEffect(() => {
  //   let interval;

  //   interval = setInterval(() => {
  //     setTimeLeft((prev) => {
  //       if (prev <= 0) {
  //         clearInterval(interval);
  //         return 0;
  //       }
  //       return prev - 1;
  //     });
  //   }, 1000);

  //   localStorage.setItem("timeLeft", JSON.stringify(timeLeft));

  //   return () => clearInterval(interval);
  // }, [timeLeft]);

  // تابعی برای بازنشانی تایمر
  // const resetTimer = () => {
  //   setTimeLeft(initialTime);
  //   localStorage.removeItem("timeLeft");
  // };

  // const formatTime = (seconds) => {
  //   const minutes = Math.floor(seconds / 60);
  //   const secs = seconds % 60;
  //   return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  // };
  const getBasketITemDetailForDisplay = function (details) {
    let showDetails = "";
    if (!_.isEmpty(details)) {
      JSON.parse(details)?.map((item, index) => {
        if (_.isEmpty(showDetails)) showDetails += item.text;
        else showDetails += " - <span class='fw-bold'>" + item.text + "</span>";
      });
    }
    return showDetails;
  };
  const deleteBasketItem = (basketItem) => {
    //alert("deleteBasketItem");

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-danger px-5 py-2 mr-2",
        cancelButton: "btn btn-secondary py-2  px-5",
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        showClass: {
          popup: `
        animate__animated
        animate__fadeIn
        animate__faster            `,
        },
        hideClass: {
          popup: `
        animate__animated
        animate__fadeOut
        animate__faster            `,
        },
        icon: "question",
        html: "<div class='fw-bold mb-4 fs-large'>  این تفریح از سبد خرید شما حذف شود؟ </div>",
        type: "success",
        showConfirmButton: true,

        confirmButtonText: " حذف از سبد خرید ",

        showCancelButton: true,
        cancelButtonText: " انصراف",
      })
      .then((result) => {
        if (result.value) BasketHelper.deletebasketItem(ctx, basketItem);
      });
  };

  /** ارسال فرم ***/
  const onSubmit = async (data) => {
    // navigate("/payment");
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-danger px-5 py-2 mr-2",
        cancelButton: "btn btn-secondary py-2  px-5",
      },
      buttonsStyling: false,
    });

    const paymentAmount = _.filter(ctx.basketInfo?.basketItemTemps, {
      isDeleted: false,
    }).reduce((acc, current) => acc + current.sumPrice, 0);

    swalWithBootstrapButtons
      .fire({
        showClass: {
          popup: `
        animate__animated
        animate__fadeIn
        animate__faster            `,
        },
        hideClass: {
          popup: `
        animate__animated
        animate__fadeOut
        animate__faster            `,
        },
        icon: "question",
        html: `<div class='fw-bold mb-4 fs-large'>تایید نهایی پرداخت</div>
        <div class='mb-4'> مبلغ نهایی قابل پرداخت <span class='fw-bold'>${paymentAmount.toLocaleString()} تومان</span> می باشد که از کیف پول شما کسر می گردد.<br/>
         آیا از کسر این مبلغ و ثبت سفارش خود اطمینان دارید؟</div>`,
        type: "success",
        showConfirmButton: true,

        confirmButtonText: "بله پرداخت شود",

        showCancelButton: true,
        cancelButtonText: " انصراف",
      })
      .then(async (result) => {
        if (result.value) {
          try {
            const response = await ApiBasket.putAddOrEditeBasket({
              personFullName: data.fullName,
              mobile: data.mobileNumber,
              basketItems: ctx.basketInfo?.basketItemTemps
                .filter((item) => item.isDeleted === false) // فیلتر آیتم‌های حذف نشده
                .map((item) => {
                  const newBasketItemPerson = [...item.basketItemPersonTemps]
                  delete item.basketItemPersonTemps
                  return {
                    ...item,
                    basketItemPersons: newBasketItemPerson
                  }
                }),
            });

            if (response.succeeded) {
              return (window.location.href =
                "/orderConfirmation?bid=" + response.data.basket.id);
            }
            else {
              SwalMessage({ iSsuccess: false, title: response.message, timer: 10000 });
              if (response.data.basket) {
                const { basketItems, ...others } = response.data.basket
                const basketTemps = { basketItemTemps: basketItems, ...others }
                basketTemps.basketItemTemps = basketTemps.basketItemTemps.map(item => {
                  item.basketItemPersonTemps = item.basketItemPersons
                  item.maxCount = item.maxReserveCount
                  item.minCount = item.minReserveCount
                  delete item.basketItemPersons
                  delete item.maxReserveCount
                  delete item.minReserveCount
                  return item
                })
                BasketStorage.setBasket(basketTemps)
                ctx.setbasketInfo(basketTemps);
              } else {
                BasketStorage.setBasket({})
                ctx.setbasketInfo({});
              }
            }
          }
          catch {
            toast.error("در حال حاضر امکان برقراری ارتباط با سامانه وجود ندارد، لطفا بعدا دوباره تلاش کنید.");
          }
        }
      });
  };
  return <>
    {_.filter(ctx.basketInfo?.basketItemTemps, { isDeleted: false })
      ?.length > 0 ? (
      window.innerWidth < 1200 ? (
        //************************ */ حالت موبایل سبد دارای آیتم*****************************
        _.filter(ctx.basketInfo?.basketItemTemps, { isDeleted: false })?.length >
        0 && (
          <div
            className={`card card-custom rounded-4`}
            style={{ border: "2px solid #59648f" }}
          >
            <form onSubmit={handleSubmit(onSubmit)}>
              <div
                className="card-header d-flex align-items-center justify-content-between py-md-0 px-4 px-md-5 border-bottom-0 rounded-top-4"
                style={{ minHeight: "60px" }}
              >
                <h3 className="card-title align-items-start d-flex text-purpel-dark mb-0">
                  <LocalGroceryStoreOutlined className="mr-1 text-purpel-dark" />
                  <div className="text-purpel-dark">سبد خرید شما</div>
                </h3>
                {/* <div className="fs-large ">{formatTime(timeLeft)}</div> */}
              </div>
              <div className="card-body pt-0 px-0 pb-0">
                <Col xs="12" className="px-0 pb-2">
                  <div className=" px-4">
                    {_.filter(basket?.basketItemTemps, {
                      isDeleted: false,
                    })?.map((basketItem) => (
                      <Row
                        className="  pt-5 pb-5"
                        style={{ borderTop: "1px solid #59648f" }}
                        key={basketItem.id}
                      >
                        <Col
                          xs="12"
                          className=" mb-4 my-xl-0 d-flex align-items-center "
                        >
                          <div style={{ width: "80%" }} className="d-flex align-items-center">
                            <img
                              src={
                                process.env.REACT_APP_PHOTOPATH_WEB +
                                basketItem.amusementServiceImageUrl
                              }
                              alt=""
                              className="rounded-2 mr-3 basket-item-image"
                            />
                            <div className="my-auto flex-grow-1">
                              <div className="fw-bold fs-medium pb-1 ">
                                {basketItem.amusementServiceName}
                              </div>
                              <div
                                className="fs-09"
                                dangerouslySetInnerHTML={{
                                  __html: getBasketITemDetailForDisplay(
                                    basketItem.details
                                  ),
                                }}
                              ></div>
                              <div className="d-flex justify-content-between">
                                <div className="py-1 fs-09">
                                  تاریخ:
                              <span className="px-1 fw-bold">
                                    {basketItem.checkInDate}
                                  </span>
                                </div>
                                {basketItem.executionTime && <div className="py-1 fs-09">
                                  ساعت:
                              <span className="px-1 fw-bold">
                                    {basketItem.executionTime}
                                  </span>
                                </div>}
                              </div>
                            </div>
                            <div>
                              <Button
                                variant="light-danger"
                                className="p-1 p-sm-2 delete-button"
                                style={{
                                  position: "absolute",
                                  top: "0",
                                  left: "10px",
                                }}
                                onClick={() => deleteBasketItem(basketItem)}
                              >
                                <IconDelete fillcolor="red" width="1.3rem" />
                              </Button>
                            </div>
                          </div>
                        </Col>
                        <Col xs="12">
                          <div className="border bg-light rounded-3 px-3">
                            {basketItem.hallEventId && <div className=" my-2 my-sm-2 my-xl-0  d-flex align-items-center justify-content-between">
                              <div className=" opacity-75 mb-sm-1">تعداد صندلی ها</div>
                              <div>
                                {basketItem?.basketItemPersonTemps?.length}
                                <span className="pl-1 fs-xSmall ">عدد</span>
                              </div>
                            </div>
                            }
                            <div className=" my-2 my-sm-2 my-xl-0  d-flex align-items-center justify-content-between">
                              <div className=" opacity-75 mb-sm-1">{basketItem.hallEventId ? "مجموع نرخ مصوب" : "نرخ مصوب"}</div>
                              <div className="text-decoration-line-through">
                                <SplitNumber number={basketItem.hallEventId ? basketItem.sumOriginalPrice : basketItem?.basketItemPersonTemps?.[0]?.originalPrice} />
                                <span className="pl-1 fs-xSmall ">تومان</span>
                              </div>
                            </div>
                            <div className=" my-2 my-sm-2 my-xl-0  d-flex align-items-center justify-content-between">
                              <div className=" opacity-75 mb-sm-1">{basketItem.hallEventId ? "مجموع نرخ فروش" : "نرخ فروش"}</div>
                              <div>
                                <SplitNumber number={basketItem.hallEventId ? basketItem.sumSalePrice : basketItem?.basketItemPersonTemps?.[0]?.price} />
                                <span className="pl-1 fs-xSmall ">تومان</span>
                              </div>
                            </div>
                            <div className=" d-sm-block my-2 my-sm-2 d-flex align-items-center justify-content-between">
                              <div className=" opacity-75 mb-sm-1">{basketItem.hallEventId ? "مجموع کمیسیون" : "کمیسیون"}</div>
                              <div>
                                <SplitNumber
                                  number={basketItem.hallEventId ? basketItem.commissionAmount : basketItem.basketItemPersonTemps?.[0]?.commissionAmount}
                                />
                                <span className="pl-1 fs-xSmall ">تومان</span>
                              </div>
                            </div>

                            {!basketItem.hallEventId && <div className=" d-sm-block my-2 my-sm-2 d-flex align-items-center justify-content-between">
                              <div className=" opacity-75 mb-sm-1">خالص </div>
                              <div>
                                <SplitNumber
                                  number={basketItem?.basketItemPersonTemps?.[0]?.agentPaidAmount}
                                />
                                <span className="pl-1 fs-xSmall">تومان</span>
                              </div>
                            </div>}
                            {!basketItem.hallEventId && <div className=" d-sm-block my-2 my-sm-2 d-flex align-items-center justify-content-between">
                              <div className=" opacity-75 mb-sm-1">تعداد</div>
                              <div>
                                <select
                                  className="form-select text-center"
                                  style={{ width: "70px" }}
                                  value={basketItem.totalCount} // مقدار پیش‌فرض
                                  onChange={(e) => {
                                    setValue(e.target.value);
                                    changeBasket(
                                      basketItem,
                                      Number(e.target.value)
                                    );
                                  }} // مقدار جدید را ذخیره می‌کند
                                >
                                  {" "}
                                  {[
                                    ...Array(
                                      _.toInteger(basketItem.maxCount) + 1
                                    ),
                                  ].map(
                                    (x, i) =>
                                      (i >= basketItem.minCount || i == 0) && (
                                        <option value={i}>{i}</option>
                                      )
                                  )}
                                </select>
                              </div>
                            </div>}
                            <div className={`d-sm-block my-3 d-flex align-items-center justify-content-between ${!basketItem.hallEventId && "border-top pt-3"}`}>
                              <div className=" opacity-75 mb-sm-1">مجموع خالص پرداختی</div>
                              <div>
                                <span className="fw-bold text-danger">
                                  <SplitNumber number={basketItem.sumPrice} />
                                </span>
                                <span className="pl-1 fs-xSmall">تومان</span>
                              </div>
                            </div>
                          </div>
                        </Col>
                        {basketItem.hallEventId && <div className="pt-2 mt-2 px-4 seat-list">
                          {basketItem.basketItemPersonTemps.map(seat =>
                            <Row className="item-box-row selected-item flex-shrink-0 border mx-0 p-2" key={seat.id} >
                              <Col className="pe-0">
                                <div style={{ fontSize: 11 }} className="d-flex flex-grow-1 align-items-center mb-2 p-0 gap-2">
                                  <div>بلوک: {seat.hallBlockName}</div>
                                  <div>-</div>
                                  <div>ردیف: {seat.hallRowName}</div>
                                  <div>-</div>
                                  <div>صندلی: {seat.hallSeatName}</div>
                                </div>
                                <div className="d-flex gap-3 p-0 align-items-center justify-content-between">
                                  <div style={{ fontSize: 11 }} className="d-flex gap-1 mb-1">
                                    <span>
                                      مصوب:
                                  </span>
                                    <span className="text-decoration-line-throught-rotate border-black-6 text-black-4">
                                      <SplitNumber number={seat.originalPrice} />
                                    </span>
                                  </div>
                                  <div style={{ fontSize: 11 }} className="d-flex gap-1 mb-1">
                                    <span>
                                      فروش:
                                  </span>
                                    <span className="fw-bold">
                                      <SplitNumber number={seat.salePrice} />
                                    </span>
                                  </div>
                                  <div style={{ fontSize: 11 }} className="d-flex gap-1 mb-1 ps-3">
                                    <span >
                                      کمیسیون:
                                  </span>
                                    <span className="fw-bold">
                                      <SplitNumber number={seat.commissionAmount} />
                                    </span>
                                  </div>
                                </div>
                                <div style={{ width: "90%", height: 1, backgroundColor: "rgba(0,0,0,0.2)" }} className="mx-auto" />
                                <div style={{ fontSize: 11 }} className="d-flex gap-3 mb-1 pt-2">
                                  <span className="fw-bold">
                                    خالص پرداختی:
                                </span>
                                  <span className="fw-bold text-danger">
                                    <SplitNumber number={seat.agentPaidAmount} />
                                  </span>
                                </div>
                              </Col>
                              <Col
                                onClick={() => {
                                  BasketHelper.deleteBasketItemPerson(ctx, basketItem, seat)
                                }}
                                style={{
                                  maxWidth: "fit-content",
                                }}
                                xs="1"
                                className="p-0 removeSeatTrash my-auto text-end"
                              >
                                <IconDelete fill="red" />
                              </Col>
                            </Row>
                          )}
                        </div>
                        }
                      </Row>
                    ))}
                  </div>
                </Col>
              </div>
              {/* قسمت اطلاعات کلی */}
              <div className="card-footer p-0 rounded-bottom-4">
                <div
                  className="d-flex align-items-center justify-content-between border-dark-success  border-secondary px-4 py-5"
                  style={{ background: "#445495" }}
                >
                  <div className=" my-1 my-sm-0 text-white text-center">
                    <div className="fs-09 mb-2"> تعداد برنامه </div>
                    <div className="fw-bold">
                      {
                        _.filter(ctx.basketInfo?.basketItemTemps, {
                          isDeleted: false,
                        })?.length
                      }{" "}
                      <span>عدد</span>
                    </div>
                  </div>
                  <div className=" my-1 my-sm-0 text-white text-center">
                    <div className="fs-09 mb-2">تعداد بلیط </div>
                    <div className=" fw-bold">
                      {_.filter(ctx.basketInfo?.basketItemTemps, {
                        isDeleted: false,
                      }).reduce(
                        (acc, current) => acc + current.totalCount,
                        0
                      )}{" "}
                      <span>عدد</span>
                    </div>
                  </div>
                  {/* <div className="   my-1 my-sm-0 text-white text-center">
                  <div className="fs-09 mb-2"> جمع تخفیف </div>
                  <div className="">
                    <SplitNumber number={0} /> تومان
                  </div>
                </div> */}
                  <div
                    className="py-1 my-sm-0 text-white text-center rounded-2 px-4"
                    style={{ backgroundColor: "#d14873" }}
                  >
                    <div className="fs-09 mb-2"> قابل پرداخت </div>
                    <div>
                      <span className=" fw-bold fs-medium ">
                        <SplitNumber
                          number={_.filter(ctx.basketInfo?.basketItemTemps, {
                            isDeleted: false,
                          }).reduce((acc, current) => acc + current.sumPrice, 0)}
                        />
                      </span>
                    تومان
                  </div>
                  </div>
                </div>
                {/* قسمت درج اطلاعات مسافر */}
                <div className="px-4">
                  <Row className=" py-4">
                    <Col xs="12" className="font-size-lg mb-sm-2 mb-3">
                      <div className="d-flex justify-content-between">
                        <div className=" mt-2 fw-bold text-purpel-dark mb-1">
                          <Hail className="mr-1  " fontSize="large" />
                        درج اطلاعات مسافر
                      </div>
                      </div>
                      <div className="text-secondary fs-09 pt-4 pb-2 border-top mt-2">
                        برای ثبت سفارش، لطفا اطلاعات سرپرست را وارد کنید.
                    </div>
                    </Col>
                    <Col xs="12" sm="6" xl="5" className="mb-5 mb-sm-0">
                      <Row>
                        <Col className="">
                          <Controller
                            name="fullName"
                            control={control}
                            defaultValue=""
                            rules={{
                              required: "نام و نام خانوادگی ضروری است",
                            }}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="نام و نام خانوادگی سرپرست"
                                variant="outlined"
                                size="small"
                                className="w-100 rounded-start-0"
                                style={{ height: "40px" }}
                                InputProps={{
                                  style: {
                                    height: "38px",
                                  },
                                }}
                                error={!!errors.fullName}
                                helperText={
                                  errors.fullName ? errors.fullName.message : ""
                                }
                                margin="normal"
                              />
                            )}
                          />
                        </Col>
                        {/* <Col xs="auto" className="font-size-xs pl-1 ">
                        <Button
                          variant="light-primary"
                          className="py-3 px-2"
                          style={{ marginTop: "16px" }}
                        >
                          <HistoryRoundedIcon /> تاریخچه
                        </Button>
                      </Col> */}
                      </Row>
                    </Col>
                    <Col xs="12" sm="4" xl="4" className="mb-2 mb-sm-0">
                      <Controller
                        name="mobileNumber"
                        control={control}
                        defaultValue=""
                        rules={{
                          required: "شماره موبایل ضروری است",
                          pattern: {
                            value: /^09\d{9}$/,
                            message:
                              "شماره موبایل باید با 09 شروع شود و 11 کاراکتر باشد",
                          },
                          maxLength: {
                            value: 11,
                            message: "تعداد کاراکترها نمی‌تواند بیشتر از 11 باشد",
                          },
                        }}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="شماره موبایل"
                            variant="outlined"
                            fullWidth
                            error={!!errors.mobileNumber}
                            helperText={
                              errors.mobileNumber
                                ? errors.mobileNumber.message
                                : ""
                            }
                            inputProps={{ maxLength: 11 }}
                            onInput={(e) => handleInputChange(e, field)}
                            onKeyPress={handleKeyPress}
                          />
                        )}
                      />
                    </Col>
                    {/* <Col xs="12" sm="2" xl="3" className=" pl-sm-0">
                    <FormControl
                      fullWidth
                      margin="normal"
                      error={!!errors.gender}
                    >
                      <InputLabel>جنسیت</InputLabel>
                      <Controller
                        name="gender"
                        control={control}
                        defaultValue=""
                        rules={{ required: "لطفاً جنسیت را انتخاب کنید" }}
                        render={({ field }) => (
                          <Select {...field} label="جنسیت" sx={{ height: 40 }}>
                            <MenuItem value="male">مرد</MenuItem>
                            <MenuItem value="female">زن</MenuItem>
                          </Select>
                        )}
                      />
                      {errors.gender && (
                        <FormHelperText>{errors.gender.message}</FormHelperText>
                      )}
                    </FormControl>
                  </Col> */}
                  </Row>
                  <Row>
                    <div className=" pb-3 pt-2  rounded-4 rounded-top-0 ">
                      <Button
                        type="submit"
                        className="mr-1 btn btn-dark-success border-dark-success w-100 text-white"
                      >
                        پرداخت و ثبت نهایی{" "}
                      </Button>
                    </div>
                  </Row>
                </div>
              </div>
            </form>
          </div>
        )
      ) : (
        //************************ */ حالت دسکتاپ دارای آیتم*****************************

        <div>
          <div
            className={`card card-custom rounded-4`}
            style={{ border: "2px solid #59648f" }}
          >
            {/* Start Box Header */}

            {/*Start body */}
            {_.filter(ctx.basketInfo?.basketItemTemps, { isDeleted: false })
              ?.length > 0 && (
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div
                    className="card-header d-flex align-items-center justify-content-between py-md-0 px-4 px-md-5 border-bottom-0 rounded-top-4"
                    style={{ minHeight: "60px" }}
                  >
                    <h3 className="card-title align-items-start d-flex text-purpel-dark mb-0">
                      <LocalGroceryStoreOutlined className=" text-purpel-dark mr-1" />
                      <div className=" text-purpel-dark">سبد خرید شما</div>
                    </h3>
                    {/* <div className="fs-large ">{formatTime(timeLeft)}</div> */}
                  </div>
                  <div className="card-body pt-0 px-0 pb-0">
                    <Col xs="12" className="px-0 pb-2">
                      <div className=" px-4">
                        {_.filter(basket?.basketItemTemps, {
                          isDeleted: false,
                        })?.map((basketItem) => (
                          <Row
                            className=" border-top pt-5 pb-5 px-4"
                            key={basketItem.id}
                          >
                            <Col xs="1" xl="auto" className="pr-0 my-auto">
                              <Button
                                variant="light-danger"
                                className="p-1 p-sm-2 delete-button"
                                onClick={() => deleteBasketItem(basketItem)}
                              >
                                <IconDelete fillcolor="red" width="1.3rem" />
                              </Button>
                            </Col>
                            <Col xs="11" xl className=" mb-4 my-xl-0 d-flex flex-grow-1">
                              <img
                                src={
                                  process.env.REACT_APP_PHOTOPATH_WEB +
                                  basketItem.amusementServiceImageUrl
                                }
                                alt=""
                                className="rounded-2 mr-3 basket-item-image"
                              />
                              <div className="my-auto">
                                <div className="fw-bold fs-medium pb-1">
                                  {basketItem.amusementServiceName}
                                </div>
                                <div
                                  className="fs-09"
                                  dangerouslySetInnerHTML={{
                                    __html: getBasketITemDetailForDisplay(
                                      basketItem.details
                                    ),
                                  }}
                                ></div>
                                <div className="d-flex">
                                  <div style={{ marginLeft: 50 }} className="py-1 fs-09">
                                    تاریخ:
                              <span className="px-1 fw-bold">
                                      {basketItem.checkInDate}
                                    </span>
                                  </div>
                                  {basketItem.executionTime && <div className="py-1 fs-09">
                                    ساعت:
                              <span className="px-1 fw-bold">
                                      {basketItem.executionTime}
                                    </span>
                                  </div>}
                                </div>
                              </div>
                            </Col>
                            {basketItem.hallEventId ? <Col
                              className="items-box mt-4 p-2 mb-2 d-flex justify-content-between"
                              style={{
                                pointerEvents: "auto",
                                maxWidth: "fit-content",
                                minWidth: 420
                              }}
                            >
                              <div className="items-box-header bg-white rounded-2 py-1 px-2 fs-085 fw-bold">
                                مجموع
                            </div>
                              <div style={{ left: 7, top: -12 }} className="items-box-header bg-white rounded-2 py-1 ps-2 pe-1 ms-2 fs-07 fw-bold">
                                تعداد صندلی: {basketItem.basketItemPersonTemps.length}
                              </div>
                              <Col
                                xs
                                md="2"
                                xl="1"
                                style={{ minWidth: "fit-content" }}
                                className="pr-0 pl-xl-0 mobile-bg-light my-auto text-xl-center"
                              >
                                <div className="  d-sm-block my-2 my-sm-2 my-xl-0">
                                  <div className="fs-09 opacity-75 mb-sm-2">
                                    نرخ مصوب
                                </div>
                                  <div className="text-decoration-line-through">
                                    <SplitNumber number={basketItem.hallEventId ? basketItem.sumOriginalPrice : basketItem?.basketItemPersonTemps?.[0]?.originalPrice} />
                                    <span className="pl-1 fs-xSmall d-none">
                                      تومان
                                </span>
                                  </div>
                                </div>
                              </Col>
                              <Col
                                xs
                                md="2"
                                xl="1"
                                style={{ minWidth: "fit-content" }}
                                className="pr-0 pl-xl-0 mobile-bg-light my-auto text-xl-center"
                              >
                                <div className="  d-sm-block my-2 my-sm-2 my-xl-0">
                                  <div className="fs-09 opacity-75 mb-sm-2">
                                    نرخ فروش
                                </div>
                                  <div>
                                    <SplitNumber number={basketItem.hallEventId ? basketItem.sumSalePrice : basketItem?.basketItemPersonTemps?.[0]?.price} />
                                    <span className="pl-1 fs-xSmall d-none">
                                      تومان
                                </span>
                                  </div>
                                </div>
                              </Col>
                              <Col
                                xs
                                md="2"
                                xl="1"
                                style={{ minWidth: "fit-content" }}
                                className="pr-0 pl-sm-0 mobile-bg-light my-auto text-xl-center"
                              >
                                <div className=" d-sm-block my-2 my-sm-2 my-xl-0">
                                  <div className="fs-09 opacity-75 mb-sm-2">
                                    کمیسیون
                                </div>
                                  <div>
                                    <SplitNumber
                                      number={basketItem.hallEventId ? basketItem.commissionAmount : basketItem.basketItemPersonTemps?.[0]?.commissionAmount}
                                    />
                                    <span className="pl-1 fs-xSmall d-none">
                                      تومان
                                </span>
                                  </div>
                                </div>
                              </Col>
                              <Col
                                xs
                                md="2"
                                xl="1"
                                style={{ minWidth: "fit-content" }}
                                className="pr-0 pl-sm-0  mobile-bg-light my-auto text-xl-center"
                              >
                                <div className=" d-sm-block my-2 my-sm-2 my-xl-0">
                                  <div className=" fs-09 opacity-75 mb-sm-2">
                                    خالص پرداختی
                              </div>
                                  <div>
                                    <span className="fw-bold text-danger">
                                      <SplitNumber number={basketItem.sumPrice} />
                                    </span>
                                    <span className="pl-1 fs-xSmall d-none">
                                      تومان
                                </span>
                                  </div>
                                </div>
                              </Col>
                            </Col> :
                              <>
                                <Col
                                  xs
                                  md="2"
                                  xl="1"
                                  style={{ minWidth: "fit-content" }}
                                  className="pr-0 pl-xl-0 mobile-bg-light my-auto text-xl-center"
                                >
                                  <div className="  d-sm-block my-2 my-sm-2 my-xl-0">
                                    <div className="fs-09 opacity-75 mb-sm-2">
                                      نرخ مصوب
                                </div>
                                    <div className="text-decoration-line-through">
                                      <SplitNumber number={basketItem.hallEventId ? basketItem.sumOriginalPrice : basketItem?.basketItemPersonTemps?.[0]?.originalPrice} />
                                      <span className="pl-1 fs-xSmall d-none">
                                        تومان
                                </span>
                                    </div>
                                  </div>
                                </Col>
                                <Col
                                  xs
                                  md="2"
                                  xl="1"
                                  style={{ minWidth: "fit-content" }}
                                  className="pr-0 pl-xl-0 mobile-bg-light my-auto text-xl-center"
                                >
                                  <div className="  d-sm-block my-2 my-sm-2 my-xl-0">
                                    <div className="fs-09 opacity-75 mb-sm-2">
                                      نرخ فروش
                                </div>
                                    <div>
                                      <SplitNumber number={basketItem.hallEventId ? basketItem.sumSalePrice : basketItem?.basketItemPersonTemps?.[0]?.price} />
                                      <span className="pl-1 fs-xSmall d-none">
                                        تومان
                                </span>
                                    </div>
                                  </div>
                                </Col>
                                <Col
                                  xs
                                  md="2"
                                  xl="1"
                                  style={{ minWidth: "fit-content" }}
                                  className="pr-0 pl-sm-0 mobile-bg-light my-auto text-xl-center"
                                >
                                  <div className=" d-sm-block my-2 my-sm-2 my-xl-0">
                                    <div className="fs-09 opacity-75 mb-sm-2">
                                      کمیسیون
                                </div>
                                    <div>
                                      <SplitNumber
                                        number={basketItem.hallEventId ? basketItem.commissionAmount : basketItem.basketItemPersonTemps?.[0]?.commissionAmount}
                                      />
                                      <span className="pl-1 fs-xSmall d-none">
                                        تومان
                                </span>
                                    </div>
                                  </div>
                                </Col>
                                <Col
                                  xs
                                  md="2"
                                  xl="1"
                                  style={{ maxWidth: 110, minWidth: 110 }}
                                  className="pr-0 pl-sm-0 mobile-bg-light my-auto text-xl-center"
                                >
                                  <div className=" d-sm-block my-2 my-sm-2 my-xl-0">
                                    <div className=" fs-09 opacity-75 mb-sm-2">
                                      خالص{" "}
                                    </div>
                                    <div>
                                      <SplitNumber
                                        number={
                                          basketItem.basketItemPersonTemps?.[0]?.agentPaidAmount
                                        }
                                      />
                                      <span className="pl-1 fs-xSmall d-none">
                                        تومان
                                </span>
                                    </div>
                                  </div>
                                </Col>
                                <Col
                                  xs="2"
                                  md="2"
                                  xl="1"
                                  style={{ maxWidth: 110, minWidth: 110 }}
                                  className="pr-0 pl-sm-0  mobile-bg-light my-auto text-xl-center"
                                >
                                  <div className=" d-sm-block my-2 my-sm-2 my-xl-0">
                                    <div className=" fs-09 opacity-75">تعداد </div>
                                    <div>
                                      <select
                                        className="form-select text-center"
                                        value={basketItem.totalCount} // مقدار پیش‌فرض
                                        onChange={(e) => {
                                          setValue(e.target.value);
                                          changeBasket(
                                            basketItem,
                                            Number(e.target.value)
                                          );
                                        }} // مقدار جدید را ذخیره می‌کند
                                      >
                                        {" "}
                                        {[
                                          ...Array(
                                            _.toInteger(basketItem.maxCount) + 1
                                          ),
                                        ].map(
                                          (x, i) =>
                                            (i >= basketItem.minCount || i == 0) && (
                                              <option value={i}>{i}</option>
                                            )
                                        )}
                                      </select>
                                    </div>
                                  </div>
                                </Col>
                                <Col
                                  xs
                                  md="2"
                                  xl="1"
                                  style={{ minWidth: "fit-content" }}
                                  className="pr-0 pl-sm-0  mobile-bg-light my-auto text-xl-center"
                                >
                                  <div className=" d-sm-block my-2 my-sm-2 my-xl-0">
                                    <div className=" fs-09 opacity-75 mb-sm-2">
                                      خالص پرداختی
                              </div>
                                    <div>
                                      <span className="fw-bold text-danger">
                                        <SplitNumber number={basketItem.sumPrice} />
                                      </span>
                                      <span className="pl-1 fs-xSmall d-none">
                                        تومان
                                </span>
                                    </div>
                                  </div>
                                </Col>
                              </>
                            }
                            {basketItem.hallEventId && <div className="pt-2 mt-2 p-0 seat-list">
                              {basketItem.basketItemPersonTemps.map(seat =>
                                <Row className="item-box-row selected-item flex-shrink-0 border mx-0 p-2" key={seat.id} >
                                  <Col
                                    onClick={() => {
                                      BasketHelper.deleteBasketItemPerson(ctx, basketItem, seat)
                                    }}
                                    style={{
                                      maxWidth: 40,
                                    }}
                                    xs="1"
                                    className="p-0 removeSeatTrash my-auto text-end"
                                  >
                                    <IconDelete fill="red" />
                                  </Col>
                                  <Col className="d-flex">
                                    <div style={{ fontSize: 12 }} className="d-flex flex-grow-1 align-items-center mb-1 p-0 gap-2">
                                      <div>بلوک: {seat.hallBlockName}</div>
                                      <div>-</div>
                                      <div>ردیف: {seat.hallRowName}</div>
                                      <div>-</div>
                                      <div>صندلی: {seat.hallSeatName}</div>
                                    </div>
                                    <div className="d-flex gap-3 p-0 align-items-center justify-content-start">
                                      <div style={{ fontSize: 12, width: 100 }} className="d-flex gap-1 justify-content-end mb-1">
                                        <span className="text-decoration-line-throught-rotate border-black-6 text-black-4">
                                          <SplitNumber number={seat.originalPrice} />
                                        </span>
                                      </div>
                                      <div style={{ fontSize: 12, width: 100 }} className="d-flex gap-1 justify-content-end mb-1">
                                        <span className="fw-bold">
                                          <SplitNumber number={seat.salePrice} />
                                        </span>
                                      </div>
                                      <div style={{ fontSize: 12, width: 100 }} className="d-flex gap-1 justify-content-end mb-1 ps-3">
                                        <span className="fw-bold">
                                          <SplitNumber number={seat.commissionAmount} />
                                        </span>
                                      </div>
                                      <div style={{ fontSize: 12, width: 100 }} className="d-flex text-danger gap-1 justify-content-end mb-1">
                                        <span className="fw-bold">
                                          <SplitNumber number={seat.agentPaidAmount} />
                                        </span>
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              )}
                            </div>
                            }
                          </Row>
                        ))}
                      </div>
                    </Col>
                  </div>
                  {/* قسمت اطلاعات کلی */}
                  <div className="card-footer p-0 rounded-bottom-4">
                    <div
                      className="d-flex align-items-center justify-content-end border-dark-success  border-secondary px-4 py-5"
                      style={{ background: "#4c5888" }}
                    >
                      <div className="d-xl-flex justify-content-between justify-content-sm-start d-sm-block my-1 my-sm-0 text-white mx-5">
                        <div> تعداد برنامه </div>
                        <div className="pe-1 fw-bold">
                          {
                            _.filter(ctx.basketInfo?.basketItemTemps, {
                              isDeleted: false,
                            })?.length
                          }{" "}
                          <span>عدد</span>
                        </div>
                      </div>
                      <div className="d-xl-flex  justify-content-between justify-content-sm-start d-sm-block my-1 my-sm-0 text-white mx-5">
                        <div>تعداد بلیط </div>
                        <div className="pe-1 fw-bold">
                          {_.filter(ctx.basketInfo?.basketItemTemps, {
                            isDeleted: false,
                          }).reduce(
                            (acc, current) => acc + current.totalCount,
                            0
                          )}{" "}
                          <span>عدد</span>
                        </div>
                      </div>
                      {/* <div className=" d-xl-flex  justify-content-between justify-content-sm-start d-sm-block my-1 my-sm-0 text-white">
                    <div> جمع تخفیف </div>
                    <div className="pe-1">
                      <SplitNumber number={0} /> تومان
                    </div>
                  </div> */}
                      <div
                        className=" d-xl-flex align-items-center justify-content-between justify-content-sm-start  d-sm-block my-1 my-sm-0 bg-danger rounded-3 text-white px-4 py-1"
                        style={{ color: "#ddd" }}
                      >
                        <div> قابل پرداخت </div>
                        <div className="pe-1">
                          <span className=" fw-bold fs-medium px-1">
                            <SplitNumber
                              number={_.filter(ctx.basketInfo?.basketItemTemps, {
                                isDeleted: false,
                              }).reduce(
                                (acc, current) => acc + current.sumPrice,
                                0
                              )}
                            />
                          </span>
                        تومان
                      </div>
                      </div>
                    </div>
                    {/* قسمت درج اطلاعات مسافر */}
                    <div className="px-4">
                      <Row className=" py-4">
                        <Col xs="12" className="font-size-lg mb-sm-2 mb-3">
                          <div className=" mt-2 fw-bold mb-1 text-purpel-dark">
                            <Hail className="mr-1" fontSize="large" />
                          درج اطلاعات مسافر
                        </div>
                          <div className="text-secondary fs-09 pt-4 pb-2 border-top mt-2">
                            برای ثبت سفارش، لطفا اطلاعات سرپرست را وارد کنید.
                        </div>
                        </Col>
                        <Col xs="12" sm="6" lg="4" xl="4" className="mb-5 mb-sm-0">
                          <Row className="d-flex">
                            <Col className=" pr-sm-0">
                              <Controller
                                name="fullName"
                                control={control}
                                defaultValue=""
                                rules={{
                                  required: "نام و نام خانوادگی ضروری است",
                                }}
                                render={({ field }) => (
                                  <TextField
                                    {...field}
                                    label="نام و نام خانوادگی سرپرست"
                                    variant="outlined"
                                    size="small"
                                    className="w-100 rounded-start-0"
                                    InputProps={{
                                      style: {
                                        height: "40px",
                                      },
                                    }}
                                    error={!!errors.fullName}
                                    helperText={
                                      errors.fullName ? errors.fullName.message : ""
                                    }
                                    margin="normal"
                                  />
                                )}
                              />
                            </Col>
                            {/* <Col
                          xs="auto"
                          className="font-size-xs pl-1 d-none d-sm-block "
                        >
                          <Button
                            variant="light-primary"
                            className=" fs-small"
                            style={{ height: "38px", marginTop: "15px" }}
                          >
                            <HistoryRoundedIcon /> تاریخچه
                          </Button>
                        </Col> */}
                          </Row>
                        </Col>
                        <Col
                          xs="12"
                          sm="4"
                          lg="4"
                          xl="4"
                          className="mb-5 mb-sm-0 mt-5"
                        >
                          <Controller
                            name="mobileNumber"
                            control={control}
                            defaultValue=""
                            rules={{
                              required: "شماره موبایل ضروری است",
                              pattern: {
                                value: /^09\d{9}$/,
                                message:
                                  "شماره موبایل باید با 09 شروع شود و 11 کاراکتر باشد",
                              },
                              maxLength: {
                                value: 11,
                                message:
                                  "تعداد کاراکترها نمی‌تواند بیشتر از 11 باشد",
                              },
                            }}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="شماره موبایل"
                                variant="outlined"
                                fullWidth
                                error={!!errors.mobileNumber}
                                helperText={
                                  errors.mobileNumber
                                    ? errors.mobileNumber.message
                                    : ""
                                }
                                inputProps={{ maxLength: 11 }}
                                onInput={(e) => handleInputChange(e, field)}
                                onKeyPress={handleKeyPress}
                              />
                            )}
                          />
                        </Col>
                        <Col xs="12" sm="2" lg="4" xl="auto" className=" pl-sm-0">
                          {/* <FormControl
                        fullWidth
                        margin="normal"
                        error={!!errors.gender}
                      >
                        <InputLabel>جنسیت</InputLabel>
                        <Controller
                          name="gender"
                          control={control}
                          defaultValue=""
                          rules={{ required: "لطفاً جنسیت را انتخاب کنید" }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              label="جنسیت"
                              sx={{ height: 40 }}
                            >
                              <MenuItem value="male">مرد</MenuItem>
                              <MenuItem value="female">زن</MenuItem>
                            </Select>
                          )}
                        />
                        {errors.gender && (
                          <FormHelperText>
                            {errors.gender.message}
                          </FormHelperText>
                        )}
                     </FormControl> */}
                          <Button
                            type="submit"
                            className="mr-1 px-5 mt-5 btn btn-dark-success border-dark-success text-white w-100"
                          >
                            پرداخت و ثبت نهایی{" "}
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </form>
              )}
          </div>
        </div>
      )
    ) : (
      //************************ سبد خرید خالی ****************************
      <div className="card card-custom rounded-4">
        <div className="card-body px-0">
          <Col className="text-center">
            <div className="w-50 mx-auto opacity-50 ">
              <IconEmptyBasket />
            </div>
            <h3 className="mt-5 pt-5 fw-bold  fs-large">
              سبد خرید شما خالی است!
          </h3>
            <div className="mt-3  fs-normal">
              برای مشاهده لیست تفریحات از لینک زیر استفاده کنید.
          </div>
            <div>
              <Link to="/tourism" className="btn btn-primary mt-3 px-5">
                {" "}
              لیست تفریحات
            </Link>
            </div>
          </Col>
        </div>
      </div>
    )}
  </>;
};
export default Basket;
